<template>
  <div class="mb-12" :class="$vuetify.breakpoint.name === 'lg' ? 'pr-12 pl-8' : 'px-3'">
    <v-dialog
      v-model="dialog.student"
      persistent
      width="800">
      <v-card class="px-6 py-3">
        <v-card-title class="px-2">
          Data Transaksi
        </v-card-title>
        <div 
          v-if="process.student" 
          class="text-center">
          <v-skeleton-loader
            ref="skeleton"
            type="table-tbody"
            class="mx-auto">
          </v-skeleton-loader>
        </div>
        <v-simple-table 
          v-if="!process.student" 
          :fixed-header="true"
          style="max-height: 400px; overflow-y: auto">
          <template v-slot:default>
            <thead>
              <tr>
                <th>No</th>
                <th>Nama</th>
                <th>Email</th>
                <th>Telephone</th>
                <th>
                  <v-checkbox
                    color="cyan darken-3"
                    v-model="addAll"
                    v-on:change="addAllStudent()">
                  </v-checkbox>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="( l, index ) in student"
                :key="index">
                <td>{{ index+1 }}</td>
                <td class="cyan--text text--darken-3">
                    {{ l.userFullname }}
                </td>
                <td>{{ l.userEmail }}</td>
                <td>{{ l.userPhoneNumber }}</td>
                <td>
                  <v-checkbox
                    v-model="addStudent"
                    color="cyan darken-3"
                    :value="l">
                  </v-checkbox>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <div class="text-center">
          <v-alert 
            type="error" 
            text
            dense
            prominent
            v-show="response !== ''">
            {{ response }}
          </v-alert>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            rounded
            small
            width="120"
            color="#ff618a"
            elevation="0"
            :disabled="process.addStudent || process.student"
            :loading="process.addStudent"
            class="mt-5 mb-0 white--text text-capitalize"
            @click="addStudentLate">
            Simpan
          </v-btn>
          <v-btn
            small
            rounded
            width="120"
            elevation="0"
            class="mt-5 mb-0 text-capitalize"
            :disabled="process.addStudent || process.student"
            @click="dialog.student = false">
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog.publish"
      persistent
      width="450">
      <v-card class="pa-4">
        <v-card-text class="body-2 pt-3 pb-5">
          Apakah Anda yakin untuk 
          <span v-if="detail.classesStatus !== 'publish'">mengaktifkan</span> 
          <span v-if="detail.classesStatus === 'publish'">menonaktifkan</span> kelas ini ?
        </v-card-text>
        <div class="text-center">
          <v-alert 
            type="error" 
            text
            dense
            prominent
            v-show="response !== ''">
            {{ response }}
          </v-alert>
        </div>
        <v-card-actions class="pb-4">
          <v-spacer></v-spacer>
          <v-btn
            rounded
            small
            width="120"
            color="#ff618a"
            elevation="0"
            :disabled="process.create"
            :loading="process.create"
            class="white--text text-capitalize"
            @click="toPublish">
            <span v-if="detail.classesStatus !== 'publish'">Aktifkan</span> 
            <span v-if="detail.classesStatus === 'publish'">Non-aktifkan</span>
          </v-btn>
          <v-btn
            rounded
            small
            width="120"
            elevation="0"
            class="text-capitalize"
            :disabled="process.create"
            @click="dialog.publish = false; response = ''">
            Tidak
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog.materi"
      persistent
      max-width="800">
      <v-card class="pa-6">
        <div class="d-flex font-weight-bold title text--secondary mb-2">
          Koleksi Materi
          <div class="text-right ml-auto">
            <v-btn
              rounded
              light
              small
              color="#ff618a"
              elevation="0"
              :disabled="process.create"
              class="white--text text-capitalize"
              @click="toCreateMateri">
              <v-icon small left>mdi-plus</v-icon> Materi Baru
            </v-btn>
          </div>
        </div>
        <v-row class="scrollMateriInsert">
          <v-col
            cols="12"
            sm="3"
            v-for="(l, index) in process.materi ? 8:library" 
            :key="index">
            <v-skeleton-loader
              class="ma-auto"
              :loading="process.materi"
              transition="scale-transition"
              :tile="false"
              type="card">
              <v-card
                flat
                class="mx-auto">
                <div v-if="!process.materi && library.length > 0">
                  <v-img
                    :src="l.silabusMateriUrlCover"
                    gradient="to top, rgba(0, 0, 0, 0.50), rgba(0, 0, 0, 0.50)"
                    height="165px">
                    <v-checkbox 
                      color="#ff618a"
                      dark
                      :hide-details="true"
                      class="mt-0 float-right"
                      :value="l"
                      v-model="selectedSM">
                    </v-checkbox>
                  </v-img>
                  <v-card-title class="px-1 body-2 pb-0 cursor-pointer">
                    {{ l.silabusMateriTitle }}
                  </v-card-title>
                </div>
              </v-card>
            </v-skeleton-loader>
          </v-col>
        </v-row>
        <div class="text-center">
          <v-alert 
            type="error" 
            text
            dense
            prominent
            v-show="response !== ''">
            {{ response }}
          </v-alert>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            rounded
            light
            small
            width="200"
            color="#ff618a"
            elevation="0"
            class="white--text text-capitalize"
            :disabled="process.create || selected === null"
            :loading="process.create"
            @click="updateMateri">
            Simpan
          </v-btn>
          <v-btn
            rounded
            light
            small
            width="200"
            elevation="0"
            class="text-capitalize"
            :disabled="process.create"
            @click="dialog.materi = false; resetForm()">
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog 
      v-model="dialog.fileClass" 
      persistent
      width="650">
      <v-card class="pa-5">
        <video
          id="myVideo"
          width="100%" 
          height="400px" 
          :src="detail.classesUrlOverview" 
          :poster="detail.classesUrlCover" 
          playsinline 
          controls>
        </video>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            small
            rounded
            width="100"
            elevation="0"
            class="text-capitalize mt-5 mb-0"
            @click="dialog.fileClass = false; stop()">
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog 
      v-model="dialog.fileMateri" 
      persistent
      width="650">
      <v-card class="pa-5">
        <div class="headline font-weight-bold">
          {{ materiSelected.silabusMateriTitle }}
        </div>
        <video
          id="myVideoSilabus"
          width="100%" 
          height="400px" 
          :src="materiSelected.silabusMateriUrlFile" 
          :poster="materiSelected.silabusMateriUrlCover" 
          playsinline 
          controls>
        </video>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            small
            rounded
            width="100"
            elevation="0"
            class="text-capitalize mt-5 mb-0"
            @click="dialog.fileMateri = false; stopSilabus()">
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog.form"
      persistent
      max-width="800">
      <ValidationObserver ref="observer">
        <v-card 
          class="px-5" 
          :class="silabusPage === 'update' ? 'py-5' : 'py-2'">
          <v-card-title class="pt-0 pb-1">
            <span class="headline mb-0">Silabus</span>
          </v-card-title>
          <v-card-text>
            <v-form>
              <ValidationProvider name="Judul" rules="required" v-slot="{ errors }">
                <v-text-field 
                  dense
                  outlined
                  label="Judul"
                  color="#ff618a"
                  v-model="form.silabusTitle"
                  :error-messages="errors"
                  required>
                </v-text-field>
              </ValidationProvider>
              <v-card-title class="body-2 py-0 pl-0">
                Deskripsi
              </v-card-title>
              <quill-editor 
                ref="myTextEditor" 
                v-model="form.silabusDesc"
                :options="optionSilabus">
              </quill-editor>
              <p class="caption mt-1 mb-1 red--text"
                v-show="error.silabusDesc">
                {{ error.silabusDesc }}
              </p>
            </v-form>
          </v-card-text>
          <v-card-text class="pb-0 mb-0 py-0 mb-2" v-if="silabusPage === 'create'">
            Tambah materi 
          </v-card-text>
          <v-row class="scrollMateri px-2" v-if="silabusPage === 'create'">
            <v-col
              cols="12"
              sm="3"
              v-for="(l, index) in process.materi ? 8:library" 
              :key="index">
              <v-skeleton-loader
                class="ma-auto"
                :loading="process.materi"
                transition="scale-transition"
                :tile="false"
                type="card">
                <v-card
                  flat
                  class="mx-auto">
                  <div v-if="!process.materi && library.length > 0">
                    <v-img
                      :src="l.silabusMateriUrlCover"
                      gradient="to top, rgba(0, 0, 0, 0.50), rgba(0, 0, 0, 0.50)"
                      height="165px">
                      <v-checkbox 
                        color="#F0932B"
                        dark
                        :hide-details="true"
                        class="mt-0 float-right"
                        :value="l"
                        v-model="selectedSM">
                      </v-checkbox>
                    </v-img>
                    <v-card-title class="px-1 body-2 pb-0 cursor-pointer">
                      {{ l.silabusMateriTitle }}
                    </v-card-title>
                  </div>
                </v-card>
              </v-skeleton-loader>
            </v-col>
          </v-row>
          <div class="text-center">
            <v-alert 
              type="error" 
              text
              dense
              prominent
              v-show="response !== ''">
              {{ response }}
            </v-alert>
          </div>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              rounded
              light
              small
              width="200"
              color="#ff618a"
              elevation="0"
              class="white--text text-capitalize"
              :disabled="process.create"
              :loading="process.create"
              @click="saveSilabus">
              Simpan
            </v-btn>
            <v-btn
              rounded
              light
              small
              width="200"
              elevation="0"
              class="text-capitalize"
              :disabled="process.create"
              @click="resetForm(); $refs.observer.reset()">
              Batal
            </v-btn>
          </v-card-actions>
        </v-card>
      </ValidationObserver>
    </v-dialog> 

    <v-dialog
      v-model="dialog.changeStatus"
      persistent
      max-width="450">
      <v-card class="pa-4">
        <v-card-text class="body-2 pt-3 pb-5">
          Apakah anda yakin untuk mengupdate status konfirmasi menjadi OK ?
        </v-card-text>
        <div class="text-center">
            <v-alert 
              type="error" 
              text
              dense
              prominent
              v-show="response !== ''">
              {{ response }}
            </v-alert>
          </div>
          <v-card-actions class="pb-4">
            <v-spacer></v-spacer>
            <v-btn
              rounded
              small
              width="120"
              color="#ff618a"
              elevation="0"
              :disabled="process.run"
              :loading="process.run"
              class="white--text text-capitalize"
              @click="updateStatusList()">
              <span>Siaap</span>
            </v-btn>
            <v-btn
              rounded
              small
              width="120"
              elevation="0"
              class="text-capitalize"
              :disabled="process.run"
              @click="dialog.changeStatus = false; response = ''">
              Tidak
            </v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog.activation"
      persistent
      width="450">
      <v-card class="pa-4">
        <v-card-text class="body-2 pt-3 pb-5">
          Aktifkan kelas terlebih dahulu sebelum menambah siswa
        </v-card-text>
        <div class="text-center">
          <v-alert 
            type="error" 
            text
            dense
            prominent
            v-show="response !== ''">
            {{ response }}
          </v-alert>
        </div>
        <v-card-actions class="pb-4">
          <v-spacer></v-spacer>
          <v-btn
            rounded
            small
            width="120"
            color="#ff618a"
            elevation="0"
            :disabled="process.create"
            :loading="process.create"
            class="white--text text-capitalize"
            @click="toPublish">
            <span>Aktifkan</span> 
          </v-btn>
          <v-btn
            rounded
            small
            width="120"
            elevation="0"
            class="text-capitalize"
            :disabled="process.create"
            @click="dialog.activation = false; response = ''">
            Tidak
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog.simpan"
      persistent
      max-width="450">
      <v-card class="pa-4">
        <v-card-text class="body-2 pt-3 pb-5">
          Apakah anda yakin untuk mengupdate status pending menjadi OK ?
        </v-card-text>
        <div class="text-center">
            <v-alert 
              type="error" 
              text
              dense
              prominent
              v-show="response !== ''">
              {{ response }}
            </v-alert>
          </div>
          <v-card-actions class="pb-4">
            <v-spacer></v-spacer>
            <v-btn
              rounded
              small
              width="120"
              color="#ff618a"
              elevation="0"
              :disabled="process.addTagihan"
              :loading="process.addTagihan"
              class="white--text text-capitalize"
              @click="addTagihan()">
              <span>Siaap</span>
            </v-btn>
            <v-btn
              rounded
              small
              width="120"
              elevation="0"
              class="text-capitalize"
              :disabled="process.addTagihan"
              @click="dialog.simpan = false; response = ''">
              Tidak
            </v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>
    <section class="learning-detail">
      <v-container>
        <v-row>
          <v-col cols="12" md="9" class="white--text py-0" v-if="process.run">
            <v-skeleton-loader
              class="ma-auto"
              :loading="process.run"
              dark
              transition="scale-transition"
              type="list-item-two-line">
            </v-skeleton-loader>
          </v-col>
          <v-col cols="12" md="9" class="white--text py-0" v-if="!process.run">
            <div class="subtitile-2 font-weight-bold">
              {{ detail.classesTitle }}
            </div>
            <div class="d-flex align-end">
              <v-rating dense
                :value="5"
                readonly
                small
                color="#ff618a"
                background-color="grey darken-1"
                half-increments
                v-model="ratingGra.average">
              </v-rating>
              <div class="caption">
                ( {{ review.length }} ulasan )
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="3">
          <div align="center">
            <v-btn
              rounded
              block
              color="#FF618A"
              :disabled="detail.classesStatus === 'scheduled'"
              class="text-capitalize mt-1 white--text font-weight-bold"
              @click="dialog.publish = true">
              <b v-if="detail.classesStatus === 'draft'">Aktifkan Kelas</b>
              <b v-if="detail.classesStatus === 'publish'">Non-Aktifkan Kelas</b>
              <!-- <b v-if="detail.classesStatus === 'scheduled'">Terjadwal</b> -->
            </v-btn>
          </div>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <section>
      <v-container>
        <v-row>
          <v-col cols="12" md="8" class="pa-0">
            <v-card
              flat
              tile
              color="#333333">
              <video
                id="myVideo"
                width="100%" 
                height="400" 
                :src="playSelected" 
                :poster="thumbnailSelected" 
                playsinline 
                controls>
              </video>
            </v-card>
            <v-sheet>
              <v-tabs
                background-color="#333333"
                right
                dark
                v-if="detail.classesType === 'private'"
                v-model="selected">
                <v-tabs-slider color="#ff618a"></v-tabs-slider>
                <v-tab
                  v-for="(i, index) in $vuetify.breakpoint.name === 'sm' || $vuetify.breakpoint.name === 'xs' ? tabs : tabWeb"
                  :key="index"
                  class="body-2 text-capitalize"
                  :class="selected === index ? 'pink--text font-weight-bold' : 'white--text'"
                  @click="selected === 0 ? fetchForum() : false">
                  {{ i }}
                </v-tab>
              </v-tabs>
               <v-tabs
                background-color="#333333"
                right
                dark
                v-if="detail.classesType === 'public'"
                v-model="selected">
                <v-tabs-slider color="#ff618a"></v-tabs-slider>
                <v-tab
                  v-for="(i, index) in $vuetify.breakpoint.name === 'sm' || $vuetify.breakpoint.name === 'xs' ? tabsp : tabWebp"
                  :key="index"
                  class="body-2 text-capitalize"
                  :class="selected === index ? 'pink--text font-weight-bold' : 'white--text'"
                  @click="selected === 0 ? fetchForum() : false">
                  {{ i }}
                </v-tab>
              </v-tabs>
            </v-sheet>

            <!-- silabus -->
            <v-card
              flat
              tile
              color="#f9f9f9"
              v-if="$vuetify.breakpoint.name === 'sm' || $vuetify.breakpoint.name === 'xs' ? selected === 1 : false">
              <v-card-title class="subtitle-2 text-second px-6">
                Silabus & Materi
              </v-card-title>
              <v-divider class="mx-5"/>
              <v-card-text class="learning-viewer pa-0">
                <div v-if="process.silabus">
                  <v-skeleton-loader
                    class="ma-auto"
                    :loading="process.silabus"
                    transition="scale-transition"
                    type="list-item-two-line"
                    v-for="(l, index) in 10"
                    :key="index">
                  </v-skeleton-loader>
                </div>
                <v-expansion-panels
                  accordion
                  tile
                  flat
                  v-if="!process.silabus">
                  <v-expansion-panel
                    class="learning-silabus"
                    v-for="(l, index) in process.silabus ? 10:silabus"
                    :key="index">
                    <v-expansion-panel-header class="caption font-weight-bold text-second">
                      {{ l.silabusTitle }}
                      <template v-slot:actions>
                        <v-icon color="pink">$expand</v-icon>
                      </template>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <div class="caption text-third line-text-second" v-html="l.silabusDesc"></div>
                      <div class="caption text-second font-weight-bold mt-3">
                        Materi
                      </div>
                      <v-divider class="mt-1 mb-3"/>
                      <v-list dense class="my-3" color="transparent">
                        <v-list-item
                          v-for="(materi, index) in l.silabusMateri"
                          :key="index"
                          class="cursor-pointer"
                          @click="changeMateriSelected(materi)">
                          <v-list-item-avatar tile size="50">
                            <v-img
                              style="border-radius: 10px;"
                              class="align-center"
                              :src="materi.silabusMateriUrlCover" 
                              height="50"
                              gradient="to top right, rgba(0,0,0,.5), rgba(0,0,0,.5)">
                              <v-card-text class="text-center">
                                <img
                                   v-if="materi.silabusMateriType!='pdf'"
                                  :src="require('../../../assets/icon/play-round.png')">
                              </v-card-text>
                            </v-img>
                          </v-list-item-avatar>
                          <v-list-item-content class="cursor-pointer">
                            <v-list-item-title class="caption font-weight-bold text-third">
                              {{ materi.silabusMateriTitle }}
                            </v-list-item-title>
                            <v-list-item-subtitle class="pink--text"
                              style="font-size: 10px;">
                              {{ materi.silabusMateriDuration * 60000 | millis }} 
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                      <Empty v-if="l.silabusMateri" v-show="l.silabusMateri.length < 1" content="Data Materi"/>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <Empty v-show="!process.silabus && silabus.length < 1" content="Data Silabus"/>
              </v-card-text>
            </v-card>
            <!-- end silabus -->

            <!-- detail class -->
            <v-card 
              flat
              v-if="$vuetify.breakpoint.name === 'sm' || $vuetify.breakpoint.name === 'xs' ? selected === 0 : selected === 0">
              <div class="pa-5" :class="$vuetify.breakpoint.name === 'xs' ? 'px-0' : ''">
                <v-row>
                  <v-col cols="12" sm="8">
                     <v-skeleton-loader
                     ref="skeleton"
                     class="mx-auto"
                     type="paragraph"
                     transition="scale-transition"
                     :loading="process.infromasi">
                      <div>
                      <div class="text-h6 font-weight-bold mb-1">
                        {{ detail.classesTitle }}
                      </div>
                      <div class="body-1 mb-5">
                        Dibuat oleh {{ detail.classesUserName }}
                      </div>
                      <div class="body-2 d-flex align-center mb-5">
                        <v-icon light small class="mr-1">mdi-shape</v-icon>
                        <div class="pt-1">
                          {{ detail.classesCategoryTitle }}  
                        </div>
                        <v-icon light small class="ml-3 mr-1">mdi-library</v-icon>
                        <div class="pt-1" v-if="detail.classesSilabus">
                          {{ detail.classesSilabus.length }} Silabus  
                        </div>
                        <v-icon light small class="ml-3 mr-1">mdi-file-video</v-icon>
                        <div class="pt-1">
                          {{ totalVideo }} video pembelajaran
                        </div>
                      </div>
                      <div class="body-2 font-weight-bold mb-1">
                        Tanggal pembuatan {{ detail.classesDateCreated | datetime }}
                      </div>
                      <div class="caption" v-if="detail.classesJoin">
                        Pengguna terdaftar {{ detail.classesJoin.length }} orang
                      </div>
                      </div>
                    </v-skeleton-loader>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-skeleton-loader
                     ref="skeleton"
                     class="mx-auto"
                     type="text"
                     transition="chip"
                     :loading="process.infromasi">
                      <div :class="$vuetify.breakpoint.name === 'sm' || $vuetify.breakpoint.name === 'xs' ? 'text-left':'py-5 px-2 text-right'">
                        <div class="headline font-weight-bold" v-if="detail.classesDiscount > 0">
                          {{
                            detail.classesPrice - ((detail.classesPrice / 100) * detail.classesDiscount) | price
                          }}
                          <sup>
                            <v-avatar color="red" size="28">
                              <small class="white--text font-weight-bold" style="font-size: 10px"> 
                                {{ detail.classesDiscount }}%
                              </small>
                            </v-avatar>
                          </sup>
                        </div>
                        <div class="subtitle-2 font-weight-bold red--text" style="text-decoration: line-through;"
                          v-if="detail.classesDiscount > 0">
                          {{ detail.classesPrice | price }}
                        </div>
                        <div class="headline font-weight-bold" v-if="detail.classesDiscount < 1">
                          <span v-if="detail.classesPrice > 0">
                            {{ detail.classesPrice | price }}
                          </span>
                          <span v-else>
                            Gratis
                          </span>
                        </div>
                      </div>
                    </v-skeleton-loader>
                  </v-col>
                </v-row>
                <v-skeleton-loader
                  ref="skeleton"
                  class="mx-auto"
                  type="paragraph"
                  transition="scale-transition"
                  :loading="process.infromasi">
                  <div class="caption mt-2 body-2"
                    v-html="detail.classesDesc">
                  </div>
                </v-skeleton-loader>
              </div>
            </v-card>
            <!-- end detail class -->

            <!-- forum -->
            <v-card
              flat
              v-if="$vuetify.breakpoint.name === 'sm' || $vuetify.breakpoint.name === 'xs' ? selected === 2 : selected === 1">
              <v-card-title class="subtitle-2 text-second font-weight-bold">
                Diskusi
              </v-card-title>
              <div v-if="process.showForum">
                <v-skeleton-loader
                  class="ma-auto"
                  :loading="process.showForum"
                  :tile="false"
                  transition="scale-transition"
                  type="list-item-avatar-two-line"
                  v-for="(s, i) in 10"
                  :key="i">
                </v-skeleton-loader>
              </div>
              <v-card-text v-if="!process.showForum">
                <v-list-item two-line class="px-0">
                  <v-list-item-avatar size="50">
                    <v-img
                      :src="user.userUrlImg" v-if="token"
                      gradient="to top right, rgba(0,0,0,.5), rgba(0,0,0,.5)">
                    </v-img>
                    <v-icon v-if="!token" x-large>mdi-account</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-card
                      outlined
                      height="60"
                      style="overflow-y: auto;">
                      <quill-editor 
                        ref="myTextEditor" 
                        v-model="form.discussion" 
                        :options="option"
                        style="height: 100%">
                      </quill-editor>
                    </v-card>
                  </v-list-item-content>
                </v-list-item>
                <v-card-actions>
                  <div class="flex-grow-1 align-center pl-2">
                    <span v-show="error.discussion" class="caption red--text">
                      {{ error.discussion }}
                    </span>
                    <span v-show="responseParrent !== ''" class="caption red--text">
                      {{ responseParrent }}
                    </span>
                  </div>
                  <v-btn
                    rounded
                    small
                    width="100"
                    height="25"
                    color="#ff618a"
                    @click="createsForum('parrent')"
                    :loading="process.forum"
                    :disabled="process.forum"
                    class="text-capitalize font-weight-bold white--text">
                    Kirim
                  </v-btn>
                </v-card-actions>
                <v-divider class="my-4"></v-divider>
                <div v-if="forum.length > 0">
                  <v-list-item 
                    class="my-2"
                    v-for="(l, index) in forum"
                    :key="index">
                    <v-list-item-avatar size="50" class="align-self-start">
                      <v-img
                        :src="l.userDetail.userUrlImg"
                        gradient="to top right, rgba(0,0,0,.5), rgba(0,0,0,.5)">
                      </v-img>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-card
                        flat>
                        <div class="caption font-weight-bold grey--text text--darken-2">
                          {{ l.userDetail.userName }}
                          <span class="mx-2 text-third caption">{{ l.forumDatetime | datetime }}</span>
                        </div>
                        <div class="grey--text text--darken-1 mt-1 caption text-third" v-html="l.forumContent"></div>
                        <div 
                          class="grey--text text--darken-2 mr-1 caption" 
                          style="margin-top: -8px">
                          <span 
                            @click="selectedReplay.ParrentId === l.id ? selectedReplay.ParrentId = '' : toSelectedForum('answer',l)" 
                            class="cursor-pointer">
                            <v-icon small>mdi-chat</v-icon> 
                            <span v-if="l.forumReplyDetail.length > 0"> 
                              {{ l.forumReplyDetail.length }} 
                            </span> Balas
                          </span>
                        </div>
                        <v-divider class="my-3" v-if="selectedReplay.ParrentId === l.id"></v-divider>
                        <div v-if="selectedReplay.ParrentId === l.id">
                          <div 
                            v-if="l.forumReplyDetail.length > 0" 
                            :class=" l.forumReplyDetail.length > 2 ? 'scrollReplay' : ''"
                            id="styleScroll">
                            <v-list-item 
                              class="my-2 scroll-child"
                              v-for="(replay, index) in l.forumReplyDetail"
                              :key="index">
                              <v-list-item-avatar 
                                :size="$vuetify.breakpoint.name === 'xs' ? 30 : 50"
                                class="align-self-start">
                                <v-img
                                  :src="replay.userDetail.userUrlImg"
                                  gradient="to top right, rgba(0,0,0,.5), rgba(0,0,0,.5)">
                                </v-img>
                              </v-list-item-avatar>
                              <v-list-item-content>
                                <v-alert 
                                  v-if="replay.forumReplyId !== null"
                                  color="#f5f5f5"
                                  dense>
                                  <div class="caption font-weight-bold grey--text text--darken-2">
                                    {{ replay.replyDetail.userDetail.userName }}
                                  </div>
                                  <div 
                                    class="grey--text text--darken-1 mt-1 caption text-third" 
                                    v-html="convert(replay.replyDetail.forumContent)">
                                  </div>
                                </v-alert>
                                <v-card
                                  flat>
                                  <div class="caption font-weight-bold grey--text text--darken-2">
                                    {{ replay.userDetail.userName }}
                                    <span class="mx-2 text-third caption">
                                      {{ replay.forumDatetime | datetime }}
                                    </span>
                                  </div>
                                  <div 
                                    class="grey--text text--darken-1 mt-1 caption text-third"
                                    v-html="replay.forumContent">
                                  </div>
                                  <div 
                                    class="c-default cursor-pointer caption"
                                    @click="toSelectedForum('replay',replay); $vuetify.goTo(`#replay`)"
                                    style="margin-top: -8px">
                                    Balas
                                  </div>
                                </v-card>
                              </v-list-item-content>
                            </v-list-item>
                          </div>
                          <span id="replay"></span>
                          <v-alert 
                            v-if="selectedReplay.Name !== ''"
                            color="#f5f5f5"
                            dense>
                            <div class="d-flex body-2 grey--text text--darken-2">
                              <span class="caption font-weight-bold grey--text text--darken-2">
                                {{ selectedReplay.Name }}
                              </span>
                              <div class="text-right ml-auto">
                                <v-icon @click="selectedReplay.Name = ''; selectedReplay.ReplyId = '';  selectedReplay.Content = ''">
                                  mdi-close
                                </v-icon>
                              </div>
                            </div>
                            <div class="mt-1 grey--text text--darken-1 mt-1 caption text-third" v-html="selectedReplay.Content"></div>
                          </v-alert>
                          <v-flex
                            class="mt-2">
                            <v-row class="align-start">
                              <v-col 
                                class="pt-0 pb-0 "
                                cols="12"
                                sm="10">
                                <v-card outlined>
                                  <v-row>
                                    <v-col 
                                      class="pt-0 pb-0">
                                      <quill-editor 
                                        ref="myTextEditor" 
                                        v-model="form.replayDiscussion"
                                        :options="optionSubDiscus">
                                      </quill-editor>
                                    </v-col>
                                  </v-row>
                                </v-card>
                                <span v-show="error.replayDiscussion" class="caption red--text pt-3">
                                  {{ error.replayDiscussion }}
                                </span>
                                <span v-show="responseChild !== ''" class="caption red--text">
                                  {{ responseChild }}
                                </span>
                              </v-col>
                              <v-col 
                                class="pt-0 pb-0"
                                cols="12"
                                sm="2"
                                :class="$vuetify.breakpoint.name === 'xs' ? 'mt-2 text-right' : ''">
                                <v-btn
                                  rounded
                                  small
                                  :block="$vuetify.breakpoint.name === 'xs' ? false : true"
                                  :height="$vuetify.breakpoint.name === 'xs' ? auto : '25'"
                                  width="90"
                                  color="#ff618a"
                                  class="text-capitalize mt-1 font-weight-bold white--text"
                                  :disabled="process.replay"
                                  :loading="process.replay"
                                  @click="createsForum('child')">
                                  Kirim
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-flex>
                        </div>
                      </v-card>
                    </v-list-item-content>
                  </v-list-item>
                </div>
                <Empty v-show="forum.length < 1" content="Diskusi"/>
              </v-card-text>
            </v-card>
            <!-- end forum -->

            <!-- review -->
            <v-card
              flat
              v-if="$vuetify.breakpoint.name === 'sm' || $vuetify.breakpoint.name === 'xs' ? selected === 3 : selected === 2">
              <v-card-title class="subtitle-2 text-second font-weight-bold" v-if="Object.keys(ratingGra).length > 0">
                Rating
              </v-card-title>
              <v-card-text>
                <v-row class="align-center" v-if="Object.keys(ratingGra).length > 0">
                  <v-col cols="12" md="3" class="text-center">
                    <div class="text-h3 text-second font-weight-bold pink--text">
                      {{ ratingGra.average }}
                    </div>
                    <v-rating dense
                      v-model="ratingGra.average"
                      readonly
                      color="#ff618a"
                      background-color="#ff618a"
                      empty-icon="$ratingFull"
                      half-increments>
                  </v-rating>
                  </v-col>
                  <v-col cols="12" md="9">
                    <div 
                      v-for="(item, index) in ratingGra.rating"
                      :key="index">
                      <div class="d-flex align-center">
                        <div class="pt-1" :class="$vuetify.breakpoint.name !== 'xs' ? 'w-progress' : 'w-xs-pro'">
                          <v-progress-linear
                            :color="selectedRating == 'all' ? '#ff618a' : selectedRating !== index ? '#BDBDBD' : '#ff618a'"
                            :background-color="selectedRating === index ? '#ff618a' : ''"
                            height="15"
                            rounded
                            :value="item.value"
                            class="cursor-pointer"
                            @click="selectedRating = index; filter.rate = 5 - index; fetchReview()">
                          </v-progress-linear>
                        </div>
                        <div 
                          class="mr-auto pl-2"
                          @click="selectedRating = index ; filter.rate = 5 - index; fetchReview()">
                          <v-icon
                            color="#ff618a" 
                            v-for="(s, index) in 5 - index" 
                            :key="index">
                            mdi-star
                          </v-icon>
                        </div>
                        <div 
                          class="ml-auto caption grey--text text--darken-1 body-1 pr-2 py-0 pt-2">
                          <span :class="selectedRating !== index ? 'pr-5' : ''">
                            {{ item.value }}%
                          </span>
                          <span v-if="selectedRating === index">
                            <v-icon 
                              small 
                              class="pl-0" 
                              @click="selectedRating = 'all'; filter.rate = ''; fetchReview()">
                              mdi-close
                            </v-icon>
                          </span>
                        </div>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-text>
                <p class="subtitle-2 text-second font-weight-bold mb-2">
                  Ulasan
                </p>
                <v-divider v-if="!process.review"></v-divider>
                <v-skeleton-loader
                  class="ma-auto"
                  :loading="process.review"
                  tile
                  transition="scale-transition"
                  type="list-item-avatar-two-line"
                  v-for="(l, index) in process.review ? 10:review"
                  :key="index">
                  <v-list dense>
                    <v-list-item
                      class="my-2"
                      v-if="review.length > 0">
                      <v-list-item-avatar 
                        size="50"
                        color="#269b91"
                        tile
                        class="align-self-start"
                        style="border: 3px solid #3a3a3a; border-radius: 6px !important;">
                        <v-img :src="l.userUrlImg"></v-img>
                      </v-list-item-avatar>
                      <v-list-item-content class="cursor-pointer" v-if="l.userReview">
                        <v-list-item-title class="caption font-weight-bold text-third">
                          {{ l.userName }}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          <v-rating dense
                            :value="l.userReview.reviewValue"
                            readonly
                            x-small
                            color="#ff618a"
                            background-color="grey darken-1">
                          </v-rating>
                        </v-list-item-subtitle>
                        <v-list-item-content class="text-third line-text-second" style="font-size: 10px;">
                          {{ l.userReview.reviewDescription }}
                        </v-list-item-content>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-skeleton-loader>
                <Empty v-show="!process.review && review.length < 1" content="Ulasan"/>
                <div class="text-center mt-5" 
                  v-if="paginationReview.totalPage > 1">
                  <v-pagination
                    v-model="pageReview"
                    :length="paginationReview.totalPage"
                    :total-visible="5"
                    color="#ff618a"
                    @input="fetchReview(pageReview)"
                    circle>
                  </v-pagination>
                </div>
              </v-card-text>
            </v-card>
            <!-- end review -->

            <!-- student -->
            <v-card
              flat
              v-if="$vuetify.breakpoint.name === 'sm' || $vuetify.breakpoint.name === 'xs' ? selected === 4 : selected === 3">
              <div class="d-flex subtitle-2 text-second font-weight-bold align-center mb-3 mt-6">
                <div>
                  Siswa
                </div>
                <div class="text-right ml-auto">
                  <v-btn
                    small
                    rounded
                    color="#FF618A"
                    class="text-capitalize white--text"
                    v-if="!detailStudent"
                    @click="detail.classesStatus === 'draft' ? dialog.activation=true:toAddStudent();">
                    Tambah Siswa
                  </v-btn>
                  <v-btn
                    small
                    rounded
                    width="120"
                    elevation="0"
                    class="text-capitalize"
                    v-if="detailStudent"
                    @click="detailStudent = false; response = ''">
                    Kembali
                  </v-btn>
                </div>
              </div>
              <div v-if="!detailStudent">
                <v-simple-table v-if="detail.classesIsCheckout === 'yes'">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">Name</th>
                        <th class="text-left">Email</th>
                        <th class="text-left">Telephone</th>
                        <th class="text-left">Preview</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(l, index) in detail.classesJoin"
                        :key="index">
                        <td>{{ l.userFullname }}</td>
                        <td>{{ l.userEmail }}</td>
                        <td>{{ l.userPhoneNumber }}</td>
                        <td>
                          <v-btn 
                          icon 
                          color="#ff618a"
                          @click="toDetail(l.id)">
                          <v-icon>mdi-eye</v-icon>
                          </v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
                <Empty v-show="detail.classesIsCheckout === 'no'" content="Data Kelas"/>
              </div>
              <div v-if="detailStudent">
                <div>
                  <v-select
                    class="hidden-md-and-up"
                    outlined
                    dense
                    v-model="sort.selected"
                    :items="sort.status"
                    :item-text="sort.status.text"
                    :item-value="sort.status.value"
                    v-on:change="toSort(sort.selected)">
                  </v-select>
                </div> 
                <v-row>
                  <v-col cols="12" md="3" class="hidden-sm-and-down">
                    <v-card flat>
                      <div class="d-flex align-baseline pb-3">
                        <v-icon small>mdi-filter</v-icon>
                        <div class="ml-1 body-2 text--secondary">
                          Filter
                        </div>
                      </div>
                      <v-radio-group v-model="sort.selected" :mandatory="false" class="mt-0">
                        <v-radio 
                          color="#ff618a"
                          v-for="(status, index) in sort.status"
                          :key="index" 
                          :label="status.text" 
                          :value="status.value"
                          v-on:change="toSort(status.value)"
                          class="py-1">
                        </v-radio>
                      </v-radio-group>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="9">
                    <div 
                      class="text-center">
                      <v-skeleton-loader
                        ref="skeleton"
                        type="table-tbody"
                        class="mx-auto px-1"
                        :loading="process.listKonfirmasi"
                        v-if="sort.selected === 'pending'">
                        <div>
                          <v-simple-table 
                            :fixed-header="true"
                            style="max-height: 400px; overflow-y: auto; overflow-x:hidden;"
                            v-if="listTagihan.length > 0">
                            <template v-slot:default>
                              <thead>
                                <tr>
                                  <th class="text-left">Angsuran ke</th>
                                  <th class="text-left">Jumlah Tagihan</th>
                                  <th class="text-left">Status</th>
                                  <th class="text-left">Aksi</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                v-for="(l,index) in listTagihan"
                                :key="index">
                                  <td class="text-left">{{index + 1}}</td>
                                  <td class="text-left">{{l.invoiceTotalPrice}}</td>
                                  <td class="text-left">
                                    <span class="grey--text text--darken-2 text-capitalize font-weight-regular" v-if="l.invoiceStatus === 'pending'">
                                      Pending
                                    </span>
                                  </td>
                                  <td class="text-left">
                                    <v-checkbox color="cyan darken-3" v-model="addTagihanLuar" :value="l">
                                    </v-checkbox>
                                  </td>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                        </div>
                        <div class="text-center">
                          <v-alert 
                            type="error" 
                            text
                            dense
                            prominent
                            v-show="response !== ''">
                            {{ response }}
                          </v-alert>
                        </div>
                        <div class="text-right">
                          <v-btn
                            rounded
                            small
                            width="120"
                            color="#ff618a"
                            elevation="0"
                            :disabled="process.addTagihan || addTagihanLuar.length < 1"
                            :loading="process.addTagihan"
                            class="mt-5 mb-0 white--text text-capitalize"
                            v-if="listTagihan.length > 0"
                            @click="dialog.simpan = true">
                            <!-- addTagihan() -->
                            Simpan
                          </v-btn>
                        </div>
                      </v-skeleton-loader>
                    
                      <v-skeleton-loader
                        ref="skeleton"
                        type="table-tbody"
                        class="mx-auto pa-1"
                        :loading="process.listKonfirmasi"
                        v-if="sort.selected === 'ok' || sort.selected === 'confirmed'">
                        <div>
                          <v-simple-table
                            v-if="listKonfirmasi.length > 0">
                            <template v-slot:default>
                              <thead>
                                <tr>
                                  <th class="text-left">No.</th>
                                  <th class="text-left">Code</th>
                                  <th class="text-left">Tagihan</th>
                                  <th class="text-left">Status</th>
                                  <th class="text-left" 
                                  v-if="sort.selected === 'confirmed'">Ubah Status</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(l,index) in listKonfirmasi"
                                :key="index">
                                  <td class="text-left">{{index+1}}</td>
                                  <td class="text-left">{{l.invoiceInstallmentCode}}</td>
                                  <td class="text-left">{{l.invoiceInstallmentTotalPrice}}</td>
                                  <td :class="sort.selected === 'ok' ? 'font-weight-bold green--text':'font-weight-bold c-default pink--text'">
                                    <span class="text-left" v-if="l.invoiceInstallmentStatus === 'ok'">
                                      Ok
                                    </span>
                                    <span class="text-left" v-if="l.invoiceInstallmentStatus === 'confirmed'">
                                    Confirmed
                                    </span>
                                  </td>
                                  <td class="bb-none text-center c-default">
                                  <v-btn
                                    rounded
                                    small
                                    elevation="0"
                                    width="110"
                                    color="#ff618a"
                                    class="text-capitalize mt-1 white--text font-weight-bold"
                                    v-if="sort.selected === 'confirmed'"
                                    @click="dialog.changeStatus = true">
                                    Ubah
                                  </v-btn>
                                  </td>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                        </div>
                      </v-skeleton-loader>
                      <Empty v-show="sort.selected === 'pending' ? !process.listKonfirmasi && listTagihan.length < 1 : !process.listKonfirmasi && listKonfirmasi.length < 1" content="Data Siswa"/>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </v-card>
            <!-- end student -->
          </v-col>

          <v-col cols="12" md="4" class="pa-0">
            <v-card
              flat
              tile
              color="#f9f9f9"
              class="hidden-sm-and-down">
              <v-row>
                <v-col cols="12" md="6"> 
                <v-card-title class="subtitle-2 text-second px-6 py-1">
                  Silabus & Materi 
                </v-card-title>
                </v-col>
                <v-col>
                <v-card-title class="text-right subtitle-2 text-second py-0">
                  <div class="text-right ml-auto">
                  <v-btn
                    small
                    rounded
                    color="#FF618A"
                    class="text-capitalize white--text"
                    :disabled="process.silabus"
                    @click="silabusPage = 'create'; dialog.form = true; fetchLibrary()">
                    Tambah Silabus
                  </v-btn>
                  </div>
                </v-card-title>
                </v-col>
              </v-row>
              <v-divider class="mx-5"/>
              <v-card-text class="learning-viewer pa-0">
                <div v-if="process.silabus">
                  <v-skeleton-loader
                    class="ma-auto"
                    :loading="process.silabus"
                    transition="scale-transition"
                    type="list-item-two-line"
                    v-for="(l, index) in 10"
                    :key="index">
                  </v-skeleton-loader>
                </div>
                <v-expansion-panels
                  accordion
                  tile
                  flat
                  v-if="!process.silabus">
                  <v-expansion-panel
                    class="learning-silabus"
                    v-for="(l, index) in process.silabus ? 10:silabus"
                    :key="index">
                    <v-expansion-panel-header class="caption font-weight-bold text-second">
                      {{ l.silabusTitle }}
                      <template v-slot:actions>
                        <v-icon  color="#ff618a">$expand</v-icon>
                      </template>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <div class="caption text-third line-text-second" v-html="l.silabusDesc"></div>
                      <div class="caption text-second font-weight-bold mt-3">
                      <v-row>
                        <v-col cols="12" md="6">
                          Materi
                        </v-col>
                        <v-col cols="12" md="6">
                          <div class="text-right ml-auto">
                            <v-btn
                              small
                              rounded
                              color="#FF618A"
                              class="white--text text-capitalize"
                              dark
                              v-if="l.silabusMateri.length < 1"
                              @click="dialog.materi = true; fetchLibrary(); form.silabusId = l.id">
                              Tambah Materi
                            </v-btn>
                            <v-btn
                              rounded
                              small
                              color="#FF618A"
                              class="text-capitalize"
                              dark
                              v-if="l.silabusMateri.length > 0"
                              @click="resetMateri(l.silabusMateri); dialog.materi = true; form.silabusId = l.id">
                              Ubah Materi
                            </v-btn>
                          </div>
                        </v-col>
                      </v-row>
                      </div>
                      <v-divider class="mt-1 mb-3"/>
                      <v-list dense class="my-3" color="transparent">
                        <v-list-item
                          v-for="(materi, index) in l.silabusMateri"
                          :key="index"
                          class="cursor-pointer"
                          @click="changeMateriSelected(materi)">
                          <v-list-item-avatar tile size="50">
                            <v-img
                              style="border-radius: 10px;"
                              class="align-center"
                              :src="materi.silabusMateriUrlCover" 
                              height="50"
                              gradient="to top right, rgba(0,0,0,.5), rgba(0,0,0,.5)">
                              <v-card-text v-if="materi.silabusMateriType!='pdf'" class="text-center">
                                <img
                                  :src="require('../../../assets/icon/play-round.png')">
                              </v-card-text>
                            </v-img>
                          </v-list-item-avatar>
                          <v-list-item-content class="cursor-pointer">
                            <v-list-item-title class="caption font-weight-bold text-third">
                              {{ materi.silabusMateriTitle }}
                            </v-list-item-title>
                            <v-list-item-subtitle 
                              v-if="materi.silabusMateriType!='pdf'"
                              class="pink--text"
                              style="font-size: 10px;">
                              {{ materi.silabusMateriDuration * 60000 | millis }} 
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                      <Empty v-if="l.silabusMateri" v-show="l.silabusMateri.length < 1" content="Data Materi"/>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <Empty v-show="!process.silabus && silabus.length < 1" content="Data Silabus"/>
              </v-card-text>
            </v-card>

            <v-row class="pa-6" v-if="$vuetify.breakpoint.name === 'lg' || $vuetify.breakpoint.name === 'md'">
              <v-col cols="12" class="py-0">
                 <p class="subtitle-2 text-second font-weight-bold pt-0 mb-0">
                  Kelas Terkait Kategori
                </p>
                <v-divider class="my-3"/>
              </v-col>
              <v-col cols="12" 
                class="pa-0"
                v-for="(l,index) in process.suggest ? 5 : suggest"
                :key="index">
                <v-skeleton-loader
                    class="ma-auto"
                    :loading="process.suggest"
                    transition="scale-transition"
                    :tile="true"
                    type="list-item-avatar-three-line">
                    <div class="hover-card border-radius pa-3">
                      <v-card
                        flat
                        class="border-radius"
                        @click="toDetail(l.id)">
                        <v-row align="center">
                          <v-col cols="4" class="pr-0 py-0">
                            <v-img
                              style="border-radius: 10px;"
                              class="align-center"
                              :src="l.classesUrlCover"
                              height="70"
                              gradient="to top right, rgba(0,0,0,.5), rgba(0,0,0,.5)">
                              <div class="badge-overlay">
                                <span class="top-left badge red"
                                  style="padding: 2px; font-size: 9px;" v-if="l.classesDiscount > 0">
                                  {{ l.classesDiscount }}%
                                </span>
                              </div>
                              <v-card-text class="text-center">
                                <img
                                  width="25"
                                  height="25"
                                  :src="require('../../../assets/icon/play-round.png')">
                              </v-card-text>
                            </v-img>
                          </v-col>
                          <v-col cols="8" class="py-0">
                            <v-card-title class="caption line-text-first font-weight-bold text-second pt-0">
                              {{ l.classesTitle }}
                            </v-card-title>
                            <v-card-subtitle class="color-default pb-0"
                              style="font-size: 10px;"
                              v-if="l.classesSilabus">
                              {{ l.classesSilabus.length }} Silabus Belajar
                            </v-card-subtitle>
                            <v-card-title class="caption font-weight-bold text-first py-0" v-if="l.classesPrice > 0">
                              {{ l.classesPrice - ((l.classesPrice / 100) * l.classesDiscount) | price }}
                            </v-card-title>
                            <v-card-title class="caption font-weight-bold text-first py-0" v-if="l.classesPrice < 1">
                              Gratis
                            </v-card-title>
                          </v-col>
                        </v-row>
                      </v-card>
                    </div>
                  </v-skeleton-loader>
                </v-col>
               <v-col cols="12">
                <Empty v-show="!process.suggest && suggest.length < 1" content="Data Sugesti Kelas"/>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </section>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "../../../service/Axios";
  import Empty from "../../../components/DataEmpty";
  import { mapKeys, mapValues, camelCase, snakeCase } from "lodash"
  export default {
    data () {
      return {
        optionSilabus: {
          modules: {
            toolbar: [
              ['bold', 'italic', 'underline'],
              [{ 'list': 'ordered'}, { 'list': 'bullet' }],
              [{ 'size': ['small', false, 'large', 'huge'] }],
              [{ 'color': [] }, { 'background': [] }],
              [{ 'align': [] }]
            ]
          },
          placeholder: 'Deskripsi . . .'
        },
        tabs: ["Informasi","Silabus & Materi", "Forum Diskusi", "Ulasan & Rating","Tambah Siswa"],
        tabWeb: ["Informasi","Forum Diskusi", "Ulasan & Rating","Tambah Siswa"],
        tabsp: ["Informasi","Silabus & Materi", "Forum Diskusi", "Ulasan & Rating"],
        tabWebp: ["Informasi","Forum Diskusi", "Ulasan & Rating"],
        option: {
          theme: 'bubble',
          placeholder: 'Tulis komentar . . .'
        },
        optionSubDiscus: {
          theme: 'bubble',
          placeholder: 'Tulis balasan . . .'
        },
        breadcrumbs: [                                             
          {
            text: 'Kelas',
            disabled: false,
            href: '/class',
          },
          {
            text: 'Detail Kelas',
            disabled: true,
            href: '/class/id',
          }
        ],
        sort: {
          selected: 'pending',
          status: [
            {
              value: 'pending',
              text: 'Menunggu Pembayaran',
            },
            {
              value: 'confirmed',
              text: 'Menunggu Konfirmasi',
            },
            {
              value: 'ok',
              text: 'Ok',
            }
          ]
        },
        dialog: {
          simpan: false,
          rating: false,
          publish: false,
          student:false,
          materi: false,
          form: false,
          fileClass: false,
          fileMateri: false,
          desc: false,
          activation: false,
          changeStatus: false
        },
        addAll: false,
        playSelected:'',
        thumbnailSelected:'',
        showDesc: false,
        descShort: '',
        silabusDescShort: '',
        totalVideo: 0,
        selected: 0,
        selectedSM: [],
        detail:{},
        dicus: '',
        forum: [],
        addTagihanLuar: [],
        silabus: [],
        selabusPagination: {},
        pageSilabus: 1,
        silabusPage: '',
        siswaPage:'',
        detailUser:'',
        library:[],
        paginationLibrary: {},
        pageLibrary: 1,
        student: [],
        listKonfirmasi:[],
        detailStudent: false,
        addStudent: [],
        data_user: [],
        materiSelected: {},
        rating: 4.5,
        ratingGra: {},
        selectedRating: 'all',
        review: [],
        suggest:[],
        listTagihan:[],
        paginationReview: {},
        pageReview: 1,
        filter: {
          rate: ''
        },
        selectedReplay: {
          ReplyId: '',
          ParrentId: '',
          Content: '',
          Name: ''
        },
        form: {
          silabusId: '',
          silabusTitle: '',
          silabusDesc: '',
          discussion: '',
          replayDiscussion: ''
        },
        error: {
          silabusDesc: '',
          discussion: '',
          replayDiscussion: ''
        },
        process: {
          run: false,
          infromasi:false,
          create: false,
          materi: false,
          forum: false,
          showForum: false,
          replay: false,
          silabus: false,
          review: false,
          rate: false,
          siswa: false,
          student: false,
          suggest: false,
          addStudent: false,
          addTagihan: false,
          listKonfirmasi:false,
          listTagihan: false,
          ubahStatus: false
        },
        response: '',
        responseParrent: '',
        responseChild: '',
      }
    },
    components: {
      Empty
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      token () {
        return this.$store.state.token
      },
      totalPrice(){
       let total  = 0
       for (let i in this.addTagihanLuar) {
        total+=this.addTagihanLuar[i].invoiceTotalPrice;
       }
       return total;
      }
    },
    mounted() {
      this.fetch()
      this.fetchSilabus()
      this.fetchForum()
      this.fetchReview()
      this.fetchSuggest()
    },
    methods: { 
      async fetch() {
        this.process.run = true
        this.process.infromasi = true
        await get(`api/internal/class/detail/${this.$route.params.id}`)
        .then((response) => {
          if (response.data.code === 200) {
            this.detail = response.data.data
            this.playSelected = this.detail.classesUrlOverview
            this.thumbnailSelected = this.detail.classesUrlCover
            this.detail.classesDesc = this.detail.classesDesc.replace(/&lt;/g, '<')
            if (this.detail.classesDesc.length > 350) {
              this.descShort = this.detail.classesDesc.substring(0, 1200) + " . . ."
            } else {
              this.descShort = this.detail.classesDesc
            }
            let item = response.data.data.classesSilabus
            for (let i in item) {
              this.totalVideo += parseInt(item[i].silabusMateri.length)
            }
            this.process.run = false
            this.process.infromasi = false
          }else{
             this.response = res.msg
          } 
        })
      },
      async fetchSuggest(){
       this.process.suggest = true
        await get(`api/internal/class`, {
          params: {
            limit:5,
            category: this.detail.classesCategoryId
          }
        })
        .then((response)=>{
          let res = response.data
          if(res.code === 200) {
            this.suggest = res.data
            this.process.suggest = false
          }else{
            this.response = res.msg
          }
        })
      },
      async fetchSilabus(p) {
        if (p === undefined) {
          this.pageSilabus = 1
        }
        this.process.silabus = true
        await get(`api/internal/class/silabus/${this.$route.params.id}`, {
          params: {
            pagenum: p
          }
        })
        .then((response) => {
          if (response.data.code === 200) {
            this.silabus = response.data.data
            if (this.silabus.length > 0) {
              for (let i in response.data.data) {
                this.silabus[i].silabusDesc = response.data.data[i].silabusDesc.replace(/&lt;/g, '<')
              }
            }
            this.selabusPagination = response.data.pagination
            this.process.silabus = false
          }
        })
      },
      async fetchLibrary() {
        this.process.materi = true
        await get(`api/internal/library`, {
          params: {
            limit: 1000000
          }
        })
        .then((response) => {
          let res = response.data
          if (res.code === 200) {
            this.process.materi = false
            this.library = []
            for (let i in response.data.data) {
              this.library.push(
                {
                  _id: response.data.data[i].id,
                  silabusMateriTitle: response.data.data[i].libraryTitle,
                  silabusMateriDesc: response.data.data[i].libraryDesc.replace(/&lt;/g, '<'),
                  silabusMateriUrlCover: response.data.data[i].libraryUrlCover,
                  silabusMateriUrlFile: response.data.data[i].libraryUrlFile,
                  silabusMateriDuration: response.data.data[i].libraryDuration,
                  silabusMateriType: response.data.data[i].libraryFormat
                }
              )
            }
            this.paginationLibrary = res.pagination
          }
        })
      },
      async fetchForum(status) {
        this.process.showForum = status === 'replay' ? false : true
        await get(`api/internal/forum/list`, {
          params: {
            classId: this.$route.params.id,
            limit: 10000
          }
        })
        .then((response) => {
          let res = response.data
          if (res.code === 200) {
            this.forum = res.data
            if (this.forum.length > 0) {
              for (let i in response.data.data) {
                this.forum[i].forumContent = response.data.data[i].forumContent.replace(/&lt;/g, '<')
                for (let j in response.data.data[i].forumReplyDetail) {
                  this.forum[i].forumReplyDetail[j].forumContent = response.data.data[i].forumReplyDetail[j].forumContent.replace(/&lt;/g, '<')
                }
              }
            }
            this.process.showForum = false
            this.process.forum = false
            this.process.replay = false
          }
        })
      },
      async fetchStudentNoClass() {
        this.process.student = true;
        await get(`api/internal/users/list`, {
          params: {
            search: "user_roles:user",
            classId: this.$route.params.id,
            limit: 100000000000
          },
        }).then((response) => {
          let res = response.data;
          if (res.code === 200) {
            this.student = []
            this.process.student = false;
            for (let i in res.data) {
              if (res.data[i].userIsInclass === 'no') {
                this.student.push(
                  res.data[i]
                )
              }
            }
            this.pagination = res.pagination;
          }
        });
      },
      toAddStudent() {
        if (this.detail.classesIsCheckout === 'yes') {
          this.dialog.student = true
          this.fetchStudentNoClass()
        } else if (this.detail.classesIsCheckout === 'no') {
          window.location = `/class/siswa/${this.$route.params.id}`
        }
      },
      addStudentLate () {
        this.data_user = []
        for (let i in this.addStudent) {
          this.data_user.push(
            {
              user_fullname: this.addStudent[i].userFullname,
              _id: this.addStudent[i].id,
              user_token_fcm: this.addStudent[i].userTokenFcm,
              user_token_fcm_mobile: '',
              user_phone_number : this.addStudent[i].userPhoneNumber,
              user_email : this.addStudent[i].userEmail,
              user_roles: this.addStudent[i].userRoles,
            }
          )
        }
        this.createsSiswaLate()
      },
      addAllStudent() {
        this.addStudent = []
        if (this.addAll === true) {
          for (let i in this.student) {
            this.addStudent.push(
              this.student[i]
            )
          }
        } else {
          this.addStudent = []
        }
      },
      stop() {
        let vid = document.getElementById("myVideo")
        vid.pause()
      },
      stopSilabus() {
        let vid = document.getElementById("myVideoSilabus")
        vid.pause()
      },
      toTop() {
        window.scrollTo({top: 0, behavior: 'smooth'})
      },
      toCreateMateri() {
        window.location = `/library/general?class=${this.$route.params.id}&silabus=${this.form.silabusId}`
      },
      changeMateriSelected(item) {
        this.materiSelected = item
        this.dialog.fileMateri = true
      },
      resetSilabus(item) {
        this.form.silabusId = item.id,
        this.form.silabusTitle = item.silabusTitle,
        this.form.silabusDesc = item.silabusDesc
        this.dialog.form = true
      },
      resetForm() {
        this.form.silabusId = '',
        this.form.silabusTitle = '',
        this.form.silabusDesc = ''
        this.selectedSM = []
        this.dialog.form = false
        this.dialog.materi = false
        this.process.create = false
        this.error= {
          silabusDesc: ''
        }
      },
      resetMateri(item) {
        let data = item
        for (let i in data) {
          this.selectedSM.push({
            _id: data[i].id,
            silabusMateriTitle: data[i].silabusMateriTitle,
            silabusMateriDesc: data[i].silabusMateriDesc.replace(/&lt;/g, '<'),
            silabusMateriUrlCover: data[i].silabusMateriUrlCover,
            silabusMateriUrlFile: data[i].silabusMateriUrlFile,
            silabusMateriDuration: data[i].silabusMateriDuration,
            silabusMateriType: data[i].silabusMateriType
          })
        }
        this.fetchLibrary()
      },
      changeMateriSelected(item) {
        this.materiSelected = item
        this.playSelected = item.silabusMateriUrlFile
        this.thumbnailSelected = item.silabusMateriUrlCover
      },
      validation () {
        var error = this.error,
            valid = true
        
        if (this.form.silabusDesc === '' && this.dialog.form === true) {
          error.silabusDesc = 'Kolom tidak boleh kosong'
          valid = false
        } else {
          error.silabusDesc = ''
        } 

        return valid;
      },
      async toPublish() {
        this.process.create = true
        await put(`api/internal/class/update/status/${this.detail.id}`, {
          data: {
            classesStatus: this.detail.classesStatus === 'publish' ? 'draft' : 'publish', 
          }
        })
        .then((response) => {
          if (response.data.code === 201) {
            this.dialog.publish = false
            this.dialog.activation = false
            this.fetch()
          } else {
            this.response = response.data.msg
          }
          this.process.create = false
        })
      },
      async saveSilabus() {
        this.response = ''
        const valids = this.validation()
        const isValid = await this.$refs.observer.validate()
        if (isValid & valids) {
          if (this.form.silabusId === '') {
            this.createSilabus()
          } else {
            this.updateSilabus()
          }
        }
      },
      async createSilabus() {
        this.process.create = true
        await post(`api/internal/class/create/silabus`, {
          data: {
            classesId : this.$route.params.id,
            silabusTitle : this.form.silabusTitle,
            silabusDesc : this.form.silabusDesc,
            silabusMateri : this.selectedSM 
          }
        })
        .then((response) => {
          let res = response.data
          if (res.code === 201) {
            this.fetchSilabus()
            this.resetForm()
            this.$refs.observer.reset()
          } else {
            this.process.create = false
            this.response = res.msg
          }
        })
      },
      async updateSilabus() {
        this.process.create = true
        await put(`api/internal/class/update/silabus/${this.$route.params.id}`, {
          data: {
            silabusId: this.form.silabusId,
            silabusTitle : this.form.silabusTitle,
            silabusDesc : this.form.silabusDesc,
            silabusMateri : [] 
          }
        })
        .then((response) => {
          let res = response.data
          if (res.code === 201) {
            this.fetchSilabus(this.pageSilabus)
            this.resetForm()
            this.$refs.observer.reset()
          } else {
            this.process.create = false
            this.response = res.msg
          }
        })
      },
      async updateMateri() {
        this.response = ''
        this.process.create = true
        await put(`api/internal/class/create/silabus/materi/${this.$route.params.id}`, {
          data: {
            silabusId: this.form.silabusId,
            silabusMateri : this.selectedSM
          }
        })
        .then((response) => {
          let res = response.data
          if (res.code === 201) {
            this.fetchSilabus()
            this.resetForm()
          } else {
            this.process.create = false
            this.response = res.msg
          }
        })
      },
      async fetchReview(p) {
        if (p === undefined) {
          this.pageReview = 1
        }
        this.process.review = true
        await get(`api/internal/users/list/review`, {
          params: {
            pagenum: p,
            rate: this.filter.rate,
            classId: this.$route.params.id
          }
        })
        .then((response) => {
          let res = response.data
          if (res.code === 200) {
            this.ratingGra = res.rating
            this.ratingGra.average = parseFloat(this.ratingGra.average)
            this.review = res.data
            this.paginationReview = res.pagination
            this.process.review = false
          }
        })
      },
      toDetail(id) {
        this.detailStudent = true
        this.detailUser=id
        this.siswaPage='pageTagihan'
        this.listTagihanUser()
      },
      convert(item) {
        return item.replace(/&lt;/g, '<')
      },
      toSelectedForum(status, item) {
        if (status === 'answer') {
          this.selectedReplay = {
            ReplyId: item.forumReplyId,
            ParrentId: item.id,
            Content: '',
            Name: ''
          }
        } else {
          this.selectedReplay = {
            ReplyId: item.id,
            ParrentId: item.forumParrentId,
            Content: item.forumContent,
            Name: item.userDetail.userName
          }
        }
        this.error= {
          discussion: '',
          replayDiscussion: ''
        }
      },
      validationParrent() {
        var error = this.error,
            valid = true
        
        if (this.form.discussion === '') {
          error.discussion = 'Kolom tidak boleh kosong'
          valid = false
        } else {
          error.discussion = ''
        }
        
        return valid;
      },
      validationReply() {
        var error = this.error,
            valid = true

        if (this.form.replayDiscussion === '') {
          error.replayDiscussion = 'Kolom tidak boleh kosong'
          valid = false
        } else {
          error.replayDiscussion = ''
        }
        
        return valid;
      },
      async createsForum(status) {
        this.responseParrent = ''
        this.responseChild = ''
        this.error= {
          discussion: '',
          replayDiscussion: ''
        }
        if (status === 'parrent') {
          this.selectedReplay = {
            ReplyId: '',
            ParrentId: '',
            Content: '',
            Name: ''
          }
        }
        const valids = status === 'parrent' ? this.validationParrent() : this.validationReply()
        if (valids) {
          if (status === 'parrent') {
            this.process.forum = true
          } else {
            this.process.replay = true
          }
          await post(`api/internal/forum/create`, {
            data: {
              userId : this.user.userId,
              classId : this.$route.params.id,
              content : status === 'parrent' ? this.form.discussion : this.form.replayDiscussion,
              parrentId : status === 'parrent' ? '' : this.selectedReplay.ParrentId,
              replyId : status === 'parrent' ? '' : this.selectedReplay.ReplyId
            }
          })
          .then((response) => {
            let res = response.data
            if (res.code === 201) {
              // if (status === 'parrent') {
              //   this.process.forum = false
              //   this.selectedReplay.ParrentId = ''
              // } else {
              //   this.process.replay = false
              // }
              this.form = {
                discussion: '',
                replayDiscussion: ''
              }
              this.selectedReplay.Content = ''
              this.selectedReplay.Name = ''
              this.selectedReplay.ReplyId = ''
              this.fetchForum('replay')
            } else {
              if (status === 'parrent') {
                this.process.forum = false
              } else {
                this.process.replay = false
              }
              if (status === 'parrent') {
                this.responseParrent = res.msg 
              } else {
                this.responseChild = res.msg 
              }
            }
          })
        }
      },
      async updatesReview() {
        this.response = ''
        if (this.form.rating === 0) {
          this.response = 'Harap untuk mengisi rating'
        }
        const isValid = await this.$refs.observer.validate()
        if (isValid) {
          this.process.rate = true
          await post(`users/users/update/review`, {
            data: {
              review : {
                review_class_id : this.$route.params.id,
                review_description : this.form.reviewDescription,
                review_value : this.form.rating
              }
            }
          })
          .then((response) => {
            let res = response.data
            if (res.code === 201) {
              this.dialog.rating = false
              this.$refs.observer.reset()
              this.fetchReview(this.pageReview)
              this.process.rate = false
            } else {
              this.process.rate = false
              this.response = res.msg 
            }
          })
        }
      },
      async createsSiswaLate() {
        this.process.addStudent = true;
        await post(
          `api/internal/student/in/class/late/create/${this.$route.params.id}`,
          {
            // classId: this.$route.params.id,
            data: {data_user : this.data_user},
          }
        ).then((response) => {
          let res = response.data;
          if (res.code === 200) {
            this.dialog.student = false
            this.fetch()
            this.process.addStudent = false;
          } else {
            this.process.addStudent = false;
            this.response = res.msg;
          }
        });
      },
      transformKeys(data, iteratee) {
        if (Array.isArray(data)) {
          return data.map((d) => this.transformKeys(d, iteratee));
        }

        if (data instanceof Object) {
          return mapValues(
            mapKeys(data, (_, k) => iteratee(k)),
            (v) => this.transformKeys(v, iteratee)
          );
        }

        return data;
      },
      snakeCaseKeys(data) {
        return this.transformKeys(data, snakeCase);
      },
      async addTagihan(){
        let valid = this.addTagihanLuar.length > 0
        if (valid) {
          this.process.addTagihan = true
          await post(`/api/internal/invoice/installment/pay`,{
            params:{
              userId:this.detailUser
            },
            data:{
              classId:this.$route.params.id,
              invoiceInstallmentTotalPrice:this.totalPrice,
              invoiceInstallmentData:this.snakeCaseKeys(this.addTagihanLuar)
            }
          }).then((response)=>{
            let res = response.data
            if (res.code === 201){
              this.process.addTagihan = false;
              this.dialog.simpan = false
              this.listTagihanUser()
            }else{
              this.process.addTagihan = false;
              this.response = res.msg
            }
          })
        } else {
          this.response = 'Harap pilih data yang ingin Anda ubah'
        }
      },
      async listTagihanUser() {
        this.process.listKonfirmasi = true;
        await get(
          `/api/internal/invoice/installment/${this.$route.params.id}`,
          {
            params:{
             status:this.sort.selected,
             userId:this.detailUser,
            }
          }
        ).then((response) =>{
          let res = response.data
          if(res.code === 200){
            this.listTagihan = res.data
            this.process.listKonfirmasi = false;
          }else{
            this.process.listKonfirmasi = false;
            this.response = res.msg
            // this.addTagihanLuar = []
          }
        })
      },
      async listConfirm(){
        this.process.listKonfirmasi = true
        await get(
          `/api/internal/installment/${this.$route.params.id}`,
          {
            params:{
              userId:this.detailUser,
              status:this.sort.selected
            }
          }
        ).then((response)=>{
          let res = response.data
          if(res.code === 200){
            this.listKonfirmasi = res.data
            this.process.listKonfirmasi = false;
          }else{
            this.process.listKonfirmasi = false;
            this.response = res.msg
            this.addTagihanLuar = []
          }
        })
      },
      toSort(item){
        this.sort.selected = item
        this.addTagihanLuar = []
        this.response = ''
        if (item === 'pending') {
          this.listTagihanUser()
        } else {
          this.listConfirm()
        }
      },
      async updateStatusList(){
        this.process.run = true
        await put(`/api/internal/invoice/installment/update/${this.detailUser}`,{
          data:{
            status:"ok"
          }
        }).then((response)=>{
          let res = response.data
          if(res.code === 201){
            this.process.run = false
            this.listConfirm()
            this.dialog.changeStatus = false
          }else{
            this.response = res.msg
          }
        })
      }
    }
  }
</script>

<style scoped>
  .background-class{
    background-color: #3a3a3a;
  }
  .br{
    border: 1px solid #ff618a;
    margin-top: 10px;
    border-radius: 10px;
  }
  .learning-detail {
    background-color: #3a3a3a;
  }
  .learning-viewer {
    background-color: #f9f9f9;
    height: 400px;
    overflow-y: scroll;
  }
  .learning-silabus {
    background: #f9f9f9 !important;
  }
  .learning-progress{
    max-width:75%;
    min-width:70%;
  }
  .learning-xs-pro{
    max-width: 70%;
    min-width: 65%;
  }
  .v-expansion-panel:not(:first-child)::after {
      border-top: none !important;
  }
  .v-expansion-panel::before {
    box-shadow: none !important;
  }
  .scrollMateri {
    height: 220px; 
    overflow-y: scroll;
  }
  .scrollMateriInsert {
    height: 420px; 
    overflow-y: scroll;
  }
  .scrollReplay {
    height: 300px; 
    overflow-y: scroll;
  }
  .w-progress{
    max-width:50%;
    min-width:50%;
  }
  .w-xs-pro{
    max-width: 20%;
    min-width: 20%;
  }
  .top-left{
    border-radius: 25px;
    padding: 5px;
  }
  .v-data-table__wrapper{
    overflow-x: hidden;
  }
  .w-progress{
    max-width:65%;
    min-width:60%;
  }
  .w-xs-pro{
    max-width: 55%;
    min-width: 50%;
  }
</style>